import React from "react";
import { TextField, Typography } from "@mui/material";
import { colors } from "../theme/theme";

interface DateInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  disabled?: boolean;
  required?: boolean;
  error?: string | null;
}

const DateInput: React.FC<DateInputProps> = ({
  label,
  value,
  onChange,
  min,
  max,
  error,
  disabled = false,
  required = false,
}) => {
  return (
    <div className="form-field">
      {label && (
        <Typography
          className="typography-text"
          sx={{
            fontFamily: '"Inter", sans-serif',
            fontSize: "12px",
            fontWeight: 400,
            color: colors.primary,
            width: "80%",
          }}
          variant="subtitle2"
        >
          {label}
          {required && (
            <span style={{ color: "red", marginLeft: "4px" }}>*</span>
          )}
        </Typography>
      )}
      <TextField
        size="small"
        className="text-field"
        sx={{ marginBottom: "0px", marginTop: "8px" }}
        type="date"
        margin="normal"
        value={value}
        InputLabelProps={{ shrink: true }}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        inputProps={{
          min,
          max,
          onKeyDown: (e) => e.preventDefault(),
          style: {
            fontSize: "14px",
            fontWeight: 400,
            fontFamily: '"Inter", sans-serif',
            color: " #666666",
          },
        }}
      />
      {error && (
        <Typography color="error" variant="body2">
          {error}
        </Typography>
      )}
    </div>
  );
};

export default DateInput;
